'use client'

import Link from 'next/link';
import styled from 'styled-components';

const Contact = () => {
  return (
    <Main>
      <h1 className="h3">Work With Us</h1>
      <ContactContainer>
        <ContactSection>
          <h2 className="h5">Email</h2>
          <Link className="contact-us h4" href="mailto:hello@plaen.co">hello@plaen.co</Link>
        </ContactSection>
        
        <Divider />
        
        <ContactSection>
          <h2 className="h5">Mailing Address</h2>
          <address>
            Attn: Plaen Design Co. | Suite 905<br />
            3-251 Queen St. S.<br />
            Mississauga Ontario L5M 1L7<br />
            Canada
          </address>
        </ContactSection>
      </ContactContainer>
    </Main>
  )
}

const Main = styled.main`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  gap: 2rem;
`

const ContactContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 3rem;
  max-width: 800px;
  width: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`

const ContactSection = styled.div`
  flex: 1;
  text-align: center;

  h2 {
    color: #8c8c8c;
  }
  
  .contact-us {
    color: black;
    margin-bottom: 0;
    line-height: 1;

    &:hover {
      text-decoration: underline;
    }
  }
  
  address {
    font-style: normal;
    line-height: 1.6;
    font-size: 1.1rem;
  }
`

const Divider = styled.hr`
  border: none;
  width: 1px;
  height: 100px;
  background-color: #ddd;
  margin: 0;
  
  @media (max-width: 768px) {
    width: 100px;
    height: 1px;
  }
`

export default Contact;